import { ITransactionDetailsOrder, ITransactionDetailsCustomer, ITransactionDetailsAddressesPostOtt, ITransactionDetailsPostpaidOtt, ITransactionDetailsGeneral, ITransactionDetailsCancelable } from "./types";

export default class TransactionDetailsPostpaidOtt implements ITransactionDetailsPostpaidOtt {

  general: ITransactionDetailsGeneral;
  order: ITransactionDetailsOrder;
  customer: ITransactionDetailsCustomer;
  addresses: ITransactionDetailsAddressesPostOtt;
  transaction: ITransactionDetailsCancelable;

  constructor(general: ITransactionDetailsGeneral, order: ITransactionDetailsOrder, customer: ITransactionDetailsCustomer, addresses: ITransactionDetailsAddressesPostOtt, transaction: ITransactionDetailsCancelable) {
    this.general = general;
    this.order = order;
    this.customer = customer;
    this.addresses = addresses;
    this.transaction = transaction;
  }

}
